//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

import { VueAgile } from 'vue-agile'

export default {
  name: "Home",
  components: {
    HelloWorld,
    agile: VueAgile
  },
  data() {
    return {
      ukuran:'col-sm' ,

      slide_infografis:1,
      slide: 1,
      slideCarausel: 1,


      listKegiatan : [],
      listFoto : [],
      listVideo : [],
      listInfografis : [],
      fotoIndex : 0,
      fotoObj : null,


      listCarousell : [],
      carousellx : false,

      infografisx : false,
      lorem: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Natus, ratione eum minus fuga, quasi dicta facilis corporis magnam, suscipit at quo nostrum!',

      mVideo: false,
      mFoto: false,


  
    }
  },

  methods: {

    getKegiatan(){
      fetch(this.$store.state.url.URL_CNT_KEGIATAN_TERBARU + "list", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
              des_kel: this.$store.state.ID_DES_KEL,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.listKegiatan = res_data
              // console.log(res_data);
      });
    },

    getFoto(){
      fetch(this.$store.state.url.URL_CNT_GALLERY_FOTO + "list", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
              des_kel: this.$store.state.ID_DES_KEL,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              // this.listFoto = res_data


              var data = res_data
              var arr1 = [];
              var arr2 = [];


              for (let i = 0; i < data.length; i++) {
                var count = data.length/2
                if(i < count){
                  arr1.push(data[i])
                }else{
                  arr2.push(data[i])
                }
              }

              var datax = [];
              for (let i = 0; i < arr1.length; i++) {
                if (arr2[i] == undefined) {
                  arr2[i] = null
                } 
                datax.push({
                  foto1 : arr1[i],
                  foto2 : arr2[i],
                })
                
              }

              // console.log('AAAAAAAA');
              // console.log(res_data)
              // console.log('AAAAAAAA');
              this.listFoto = datax
      });
    },



    getCarousell(){
      fetch(this.$store.state.url.URL_CNT_CAROUSELL + "list", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
              des_kel: this.$store.state.ID_DES_KEL,
          })
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.listCarousell = res_data
              this.carousellx = true
      });
    },


    getInfografis(){
      fetch(this.$store.state.url.URL_CNT_GALLERY_INFOGRAFIS + "list", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
              des_kel: this.$store.state.ID_DES_KEL,
          })
      })
          .then(res => res.json())
          .then(res_data => {

            // console.log('BBBBBBBBBBBBBBBBBB');
            console.log(res_data);
            // console.log('BBBBBBBBBBBBBBBBBB');

              this.listInfografis = res_data


              if (res_data.length <= 0) {
                this.infografisx = false
              } else {
                this.infografisx = true
              }



      });
    },

    getVideo(){
      fetch(this.$store.state.url.URL_CNT_GALLERY_VIDEO + "list4", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          },
          body: JSON.stringify({
              des_kel: this.$store.state.ID_DES_KEL,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.listVideo = res_data
              // console.log(res_data);
      });
    },


    pushKegiatan : function(id){
      this.$router.push('/detilKegiatan?id='+id);
    },

    routeTo : function(route){
      this.$router.push(route);
    },



    selectFoto(index, foto){
      this.fotoIndex = index
      console.log(index)
      if (foto == 'satu') {
        // console.log(this.listFoto[this.fotoIndex].foto1)
        this.fotoObj = this.listFoto[this.fotoIndex].foto1;
      } else {
        this.fotoObj = this.listFoto[this.fotoIndex].foto2;
      }
    },

    routerku(route){
      this.$router.push(route)
    },


    disableInfografis : function(){
      this.infografisx = false
    },


  },

  mounted () {

    this.getInfografis()
    this.getCarousell()
    this.getKegiatan();
    this.getFoto();
    this.getVideo();
  },
};
